export default __webpack_public_path__ + "static/media/about-service-in-two-minutes@3x.8482c301.png";